import React from 'react'
import { Link } from 'react-router-dom'

import './style.css'

const TableBreadcrumbs = ({ section, id, name }) => (
	<span className="knowledgebase-table-area-breadcrumbs-nav">
		{section ? (
			<span>
				<Link
					className="knowledgebase-table-area-breadcrumbs-nav-link"
					to={`/category/${id}`}
				>
					{`Drift Help / ${name}`}
				</Link>
			</span>
		) : (
			<span>
				<Link
					className="knowledgebase-table-area-breadcrumbs-nav-link"
					to="/category"
				>
					{`Drift Help /`}
				</Link>
			</span>
		)}
	</span>
)

export default TableBreadcrumbs
